/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FeatureFlagKey } from './featureFlagKey';


export interface FeatureFlagUpdateApiModel { 
    key: FeatureFlagKey;
    isEnabled: boolean;
}
export namespace FeatureFlagUpdateApiModel {
}


